export default "__VITE_ASSET__BhAWwfPo__"